/* eslint-disable no-undef */

const hankePpp = $('.hankepoiminnat').data('ppp') // posts per page
let hankeCurrentPage = 1

const newsPpp = $('.recent-news').data('ppp') // posts per page
let newsCurrentPage = 1

const feedbacksPpp = $('.feedbacks').data('ppp')
const feedbacksTotal = $('.feedbacks').data('total')
let feedbacksCurrentPage = 1
$(document).ready(function () {
  /* ----------------------------  no-link click handling  --------------------------------------------- */
  $('.not-link > a').on('click', function (event) {
    event.preventDefault()
  })
  /* -------------------- keep aspect ratio of element (in Yhteystiedot last contact box) --------------------------------- */
  keepAspectRatio($('.toimisto .wp-block-group'), 2 / 3)
  $(window).resize(function () {
    keepAspectRatio($('.toimisto .wp-block-group'), 2 / 3)
  })

  function keepAspectRatio (element, ratio) {
    if ($(window).width() > 781) {
      const width = $(element).width()
      $(element).css('height', width / ratio)
    } else {
      $(element).css('height', 'auto')
    }
  }

  /* ----------- handling animation for "Palvelumme" in front page ---------------- */

  // check if IntersectionObserver function exists
  if (typeof IntersectionObserver !== 'function') {
    $('#palvelumme .wp-block-column').addClass('slide-to-top')
  } else {
    // treshold determines how much of the element should be shown (0.3 = 30%) before activation
    let tresholdVal = 0
    if ($(window).width() <= 767) {
      tresholdVal = 0.1
    } else {
      tresholdVal = 0.3
    }
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: tresholdVal
    }

    if ($('#palvelumme')[0]) {
      // Observe element to see when it enters/leaves viewport
      const observer = new IntersectionObserver(callbackFuncPalvelumme, options)
      observer.observe($('#palvelumme')[0])
    }
  }

  function callbackFuncPalvelumme (entries, observer) {
    $(entries).each(function (index, entry) {
      // check if in viewport
      if (entry.isIntersecting) {
        /* Use promises when possible instead of simple timeouts, because visually animation timing seemed to vary. */
        if (typeof Promise !== 'function') {
          // promise not supported
          $(entry.target).find('.wp-block-column').each(function (index, element) {
            setTimeout(function () {
              $(element).addClass('slide-to-top')
            }, index * 180)
          })
        } else {
          // promise supported
          let promise = Promise.resolve()
          $(entry.target).find('.wp-block-column').each(function (index, element) {
            promise = promise
              .then(animatePalvelumme.bind(null, element, 180))
          // chaining promise so that they fire one after another
          })
        }

        // stop observer
        observer.disconnect()
      }
    })
  }

  function animatePalvelumme (element, time) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        $(element).addClass('slide-to-top')
        resolve() // resolve the promise when it's done
      }, time)
    })
  }

  /* --------------- handling numbers animation in front page ------------- */

  // check if IntersectionObserver function exists
  if (typeof IntersectionObserver !== 'function') {
    $('.animated-numbers h4').css('visibility', 'visible')
  } else {
    let tresholdVal = 0
    if ($(window).width() <= 767) {
      tresholdVal = 0.3
    } else {
      tresholdVal = 0.6
    }
    const options2 = {
      root: null,
      rootMargin: '0px',
      threshold: tresholdVal
    }
    if ($('.animated-numbers')[0]) {
      // Observe element to see when it enters/leaves viewport
      const observer2 = new IntersectionObserver(callbackFuncNumbers, options2)
      observer2.observe($('.animated-numbers')[0])
    }
  }

  function callbackFuncNumbers (entries, observer) {
    $(entries).each(function (index, entry) {
      // check if in viewport
      if (entry.isIntersecting) {
        $(entry.target).find('h4').css('visibility', 'visible')
        $(entry.target).find('h4').each(function () {
          const textContent = $(this).text()
          const number = textContent.match(/\d+/)

          const notNumbers = textContent.replace(number, '')
          let notNumbersHtml = ''

          /* add span tags around number and non-numbers (in this is assumed there are no letters/characters before the number) */
          if (notNumbers) {
            notNumbersHtml = '<span class="non-numbers">' + notNumbers + '</span>'
          }
          $(this).html('<span class="number">' + number + '</span>' + notNumbersHtml)

          animateCounter($(this).find('.number'), 2000)
        })
        // stop observer
        observer.disconnect()
      }
    })
  }

  function animateCounter (numberElement, duration) {
    $({ Counter: 0 }).animate({
      Counter: $(numberElement).text()
    }, {
      duration: duration,
      step: function () {
        $(numberElement).text(Math.ceil(this.Counter))
      }
    })
  }

  /* --------------------------- loading more hankepoiminta-posts ---------------------------- */

  $('.hankepoiminnat .load-more').on('click', loadMorePosts)

  function loadMorePosts () {
    $.ajax({
      data: {
        post_type: 'hankepoiminta',
        _ajax_nonce: myVariables.load_more_posts_nonce,
        action: 'load_more_posts',
        ppp: hankePpp,
        page: hankeCurrentPage,
        button_load_all: $('.hankepoiminnat').data('button_load_all')
      },
      type: 'POST',
      dataType: 'json',
      url: myVariables.ajax_url,
      /* execute before data fetch */
      beforeSend: function () {
        $('.hankepoiminnat .load-more').addClass('loading-more')
        $('.hankepoiminnat .load-more .more-text').html('Ladataan...')
        // prevent click event
        $('.hankepoiminnat .load-more').off('click')
      },
      /* data fetch succeeded */
      success: function (data) {
        $('.hankepoiminnat .posts-container').append(data.html)
        hankeCurrentPage = data.vars.current_page
        if ((hankeCurrentPage * parseInt(hankePpp) >= data.vars.found_posts) || data.vars.button_load_all) {
          $('.hankepoiminnat .load-more-container').css('display', 'none')
        }
      },
      /* data fetch failed */
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('FAILED')
        /* console.log('jqXHR: ', jqXHR)
          console.log('textStatus: ', textStatus)
          console.log('errorThrown: ', errorThrown) */
      },
      /* execute after every data fetch */
      complete: function (jqXHR) {
        if (!jqXHR.responseJSON.vars.button_load_all) {
          $('.hankepoiminnat .load-more').removeClass('loading-more')
          $('.hankepoiminnat .load-more .more-text').html('Näytä lisää')
          // reactivate click event
          $('.hankepoiminnat .load-more').on('click', loadMorePosts)
        }
      }
    })
  }

  /* --------------------------- loading more news-posts ---------------------------- */

  $('.recent-news .load-more').on('click', loadMoreNews)
  function loadMoreNews () {
    $.ajax({
      data: {
        post_type: 'post',
        _ajax_nonce: myVariables.load_more_posts_nonce,
        action: 'load_more_posts',
        ppp: newsPpp,
        page: newsCurrentPage,
        button_load_all: $('.recent-news').data('button_load_all'),
        count: $('.recent-news .posts-container .news').length
      },
      type: 'POST',
      dataType: 'json',
      url: myVariables.ajax_url,
      /* execute before data fetch */
      beforeSend: function () {
        $('.recent-news .load-more').addClass('loading-more')
        $('.recent-news .load-more .more-text').html('Ladataan...')
        // prevent click event
        $('.recent-news .load-more').off('click')
      },
      /* data fetch succeeded */
      success: function (data) {
        $('.recent-news .posts-container').append(data.html)
        newsCurrentPage = data.vars.current_page
        if ((newsCurrentPage * parseInt(newsPpp) >= data.vars.found_posts) || data.vars.button_load_all) {
          $('.recent-news .load-more-container').css('display', 'none')
        }
      },
      /* data fetch failed */
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('FAILED')
        /* console.log('jqXHR: ', jqXHR)
        console.log('textStatus: ', textStatus)
        console.log('errorThrown: ', errorThrown) */
      },
      /* execute after every data fetch */
      complete: function (jqXHR) {
        if (!jqXHR.responseJSON.vars.button_load_all) {
          $('.recent-news .load-more').removeClass('loading-more')
          $('.recent-news .load-more .more-text').html('Näytä lisää')
          // reactivate click event
          $('.recent-news .load-more').on('click', loadMoreNews)
        }
      }
    })
  }

  /* --------------------------- loading more feedbacks --------------------------------------- */

  $('.feedbacks .load-more').on('click', loadMoreFeedbacks)

  function loadMoreFeedbacks () {
    $.ajax({
      data: {
        _ajax_nonce: myVariables.load_more_posts_nonce,
        action: 'load_more_feedbacks',
        ppp: feedbacksPpp,
        currentIndex: feedbacksPpp * feedbacksCurrentPage,
        button_load_all: $('.feedbacks').data('button_load_all'),
        window_width: $(window).width()
      },
      type: 'POST',
      dataType: 'json',
      url: myVariables.ajax_url,
      /* execute before data fetch */
      beforeSend: function () {
        $('.feedbacks .load-more').addClass('loading-more')
        $('.feedbacks .load-more .more-text').html('Ladataan...')
        // prevent click event
        $('.feedbacks .load-more').off('click')
      },
      /* data fetch succeeded */
      success: function (data) {
        console.log(data)
        feedbacksCurrentPage++
        $('.feedbacks .wp-block-column.left').append(data.feedbacks.left)
        $('.feedbacks .wp-block-column.right').append(data.feedbacks.right)
        if ((feedbacksCurrentPage * parseInt(feedbacksPpp) >= feedbacksTotal) || data.vars.button_load_all) {
          $('.feedbacks .load-more-container').css('display', 'none')
        }
      },
      /* data fetch failed */
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('FAILED')
        /* console.log('jqXHR: ', jqXHR)
          console.log('textStatus: ', textStatus)
          console.log('errorThrown: ', errorThrown) */
      },
      /* execute after every data fetch */
      complete: function (jqXHR) {
        if (!jqXHR.responseJSON.vars.button_load_all) {
          $('.feedbacks .load-more').removeClass('loading-more')
          $('.feedbacks .load-more .more-text').html('Näytä lisää')
          // reactivate click event
          $('.feedbacks .load-more').on('click', loadMoreFeedbacks)
        }
      }
    })
  }

  /* ---------------------------------- read more news buttons--------------------------------- */

  $(document).on('click', '.has-popup .news-title, .has-popup .news-excerpt', function (event) {
    content = $(this).closest('.news').find('.popup')
    content.show()
  })

  $(document).on('click', '.close-popup', function() {
    $(this).closest('.popup').hide()
  })

  $(document).on('click', '.popup', function(e) {
    if($(e.target).hasClass('popup')) {
      $(this).hide()
    }
  })

  /* ---------------------------------- anchor link read more news buttons---------------------- */

  readMore()

  $('.anchor-link-to-news').on('click', function () {
    setTimeout(function () {
      readMore(window.location.hash)
    }, 200)
  })

  function readMore (anchor = window.location.hash) {
    content = $(anchor).find('#news-content')
    if (content.is(':hidden')) {
      $(anchor).find('.button-read-more-news').click()
    }
  }

  /* ---------------------------------- play hankepoiminnat video when button clicked ---------------------- */
  $('.hankepoiminnat').on('click', '.videoPlay', function () {
    $video = $(this).next('video')
    if ($video.get(0).paused) {
      $(this).hide()
      $video.get(0).play()
    }
  })

  $('.hankepoiminnat').on('click', 'video', function () {
    $playButton = $(this).parent().find('.videoPlay')
    if (!this.paused) {
      $($playButton).show()
      this.pause()
    }
  })

  /* -------------------------------------- when hankepoiminta video ended ---------------------------------- */

  $('.hankepoiminnat').bind('ended', '.hankepoiminta-video', function () {
    this.currentTime = 0
    $playButton = $(this).parent().find('.videoPlay')
    $($playButton).show()
  })
})
